// src/components/league-creation/league-type/RedraftConfiguration.js
import React from 'react';
import { Calendar, Shuffle, RefreshCw } from 'lucide-react';
import { dynastyTheme } from '../../../services/colorService';
import { parseIntOrPrev } from '../../../services/formUtils';

const RedraftConfiguration = ({ formData, onInputChange, error }) => {
  return (
    <div 
      className={`${dynastyTheme.components.card.base} border ${dynastyTheme.classes.border.primary}/30`}
      style={{ 
        borderRadius: dynastyTheme.tokens.radius.lg,
        padding: dynastyTheme.tokens.spacing.xl
      }}
    >
      <div className="flex items-center mb-6" style={{ gap: dynastyTheme.tokens.spacing.sm }}>
        <Calendar className={dynastyTheme.classes.text.primary} style={{ width: '1.5rem', height: '1.5rem' }} />
        <h3 className={`${dynastyTheme.classes.text.white} text-xl font-bold`}>
          Single Season Configuration
        </h3>
      </div>

      {/* Draft Rounds */}
      <div style={{ marginBottom: dynastyTheme.tokens.spacing.lg }}>
        <label className={`${dynastyTheme.components.label} ${dynastyTheme.classes.text.white}`}>
          Draft Rounds
        </label>
        <input
          type="number"
          value={formData.draft_rounds}
          onChange={(e) => onInputChange('draft_rounds', parseIntOrPrev(e.target.value, formData.draft_rounds))}
          className={`${dynastyTheme.components.input} w-full`}
          min="1"
          max="40"
        />
        <p className={`${dynastyTheme.classes.text.neutralLight} text-sm mt-1`}>
          Total number of rounds in the draft (1-40)
        </p>
        {error && error.includes('Draft rounds') && (
          <p className={`${dynastyTheme.classes.text.error} text-sm mt-1`}>
            {error}
          </p>
        )}
      </div>

      {/* Draft Type */}
      <div style={{ marginBottom: dynastyTheme.tokens.spacing.lg }}>
        <label className={`${dynastyTheme.components.label} ${dynastyTheme.classes.text.white} flex items-center`} style={{ gap: dynastyTheme.tokens.spacing.sm }}>
          <Shuffle style={{ width: '1rem', height: '1rem' }} />
          Draft Type
        </label>
        <select
          value={formData.redraft_initial_draft_type}
          onChange={(e) => onInputChange('redraft_initial_draft_type', e.target.value)}
          className={`${dynastyTheme.components.input} w-full`}
        >
          <option value="snake">Snake Draft</option>
          <option value="random_repeating">Random (Same Order Each Round)</option>
          <option value="auction" disabled>Auction Draft (Coming Soon)</option>
        </select>
        <p className={`${dynastyTheme.classes.text.neutralLight} text-sm mt-1`}>
          How the draft will work each season
        </p>
        {error && error.includes('draft type') && (
          <p className={`${dynastyTheme.classes.text.error} text-sm mt-1`}>
            {error}
          </p>
        )}
      </div>

      {/* Single Season Info Box */}
      <div 
        className={`${dynastyTheme.classes.bg.primary}/10 border ${dynastyTheme.classes.border.primary}/30`}
        style={{ 
          borderRadius: dynastyTheme.tokens.radius.md,
          padding: dynastyTheme.tokens.spacing.md
        }}
      >
        <div className="flex items-start" style={{ gap: dynastyTheme.tokens.spacing.sm }}>
          <RefreshCw className={dynastyTheme.classes.text.primary} style={{ width: '1.25rem', height: '1.25rem', marginTop: '0.125rem' }} />
          <div>
            <h4 className={`${dynastyTheme.classes.text.white} font-semibold mb-2 text-sm`}>
              Single Season Features
            </h4>
            <div className={`${dynastyTheme.classes.text.neutralLight} text-xs space-y-1`}>
              <p>• All players return to the draft pool each season</p>
              <p>• Fresh start every year - no keepers</p>
              <p>• Perfect for casual leagues or beginners</p>
              <p>• Simple season-by-season management</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RedraftConfiguration;